import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class InkService {

  // private apiUrl = "http://localhost:3003/api";
   apiUrl = "https://lexipackghana.com:3003/api";


  constructor(private http: HttpClient) { }

  addInk(data:any){
    return this.http.post(this.apiUrl+'/addInk',data);
  }
  getOrder(){
    return this.http.get(this.apiUrl+'/inkList');
  }
  // getOrderById(id: string) {
  //   return this.http.get(this.apiUrl + '/order/' + id);
  // }
  // updateOrder(id: string, data: any) {
  //   return this.http.put(this.apiUrl + '/order/' + id, data);
  // }
  // getOrderById(id: string) {
  //   return this.http.get(this.apiUrl + '/branches/' + id);
  // }
//   confirmOrder(orderId: string, confirmationData: any) {
//     return this.http.put(this.apiUrl + '/confirmOrder/' + orderId,confirmationData);
// }
// getConfirmedOrders() {
//   return this.http.get(this.apiUrl + '/confirmedOrders');
// }
}
